import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { InputText } from 'primereact/inputtext';
import { FoodAlcoholModel } from "../../../models/foodAndAlcohol";
import { InputTextarea } from 'primereact/inputtextarea';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import Language from '../../../common/components/language/language';
import { Lang } from '../../../common/enums';
import { EmaDataRowModel } from "../../../models/dataSynchronization";
import Spinner from '../../../common/components/spinner/spinner';
import DataSyncService from '../../../services/dataSyncService';
import { Checkbox } from 'primereact/checkbox';
import { InputSwitch } from 'primereact/inputswitch';
//import {Spinner} from 'primereact/spinner';

interface IProps {
  importClick: any,
  cancelClick: any,
  isVisible: boolean,
  currentRawData: EmaDataRowModel
}

interface IState {
  isLoading: boolean,
  error: any,
  currentRawData: EmaDataRowModel,
  validationMessage: string,
  selectedLangId: number,
  isNumOfDocsDiff: boolean,
}

class ImportDataAddNewDialog extends React.Component<IProps, IState> {
  dataSyncService = new DataSyncService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      error: null,
      currentRawData: props.currentRawData,
      validationMessage: '',
      selectedLangId: 2,   //Lang.bg,
      isNumOfDocsDiff: props.currentRawData.isNumOfDocsDiff,
    };
  }

  handleChange = (key, value) => {
    const currentRawData: EmaDataRowModel = { ...this.state.currentRawData };
    currentRawData[key] = value;
    this.setState({ currentRawData: { ...currentRawData } });
  };

  isValidAddEditForm() {
    let message = '';

    this.setState({
      validationMessage: ''
    });

    if (!this.state.currentRawData.emaMedicineURL) {
      message += "Please enter EMA Medicine URL.<br />";
    }

    if (!this.state.currentRawData.medicineName) {
      message += "Please enter Medicine Name.<br />";
    }

    if (!this.state.currentRawData.commonINNnames) {
      message += "Please enter Common INN names.<br />";
    }

    if (!this.state.currentRawData.activeSubstances) {
      message += "Please enter Active Substances.<br />";
    }

    if (!this.state.currentRawData.productNumber) {
      message += "Please enter EMA product number.<br />";
    }

    if (!this.state.currentRawData.numOfDocs) {
      message += "Please enter expected number of documents.<br />";
    }

    this.setState({
      validationMessage: message
    });

    return message == '';
  }

  handleImportButton = event => {
    event.preventDefault();
    if (!this.isValidAddEditForm()) return;

    const currentRawData = this.state.currentRawData;
    //this.props.importClick(currentRawData);
    this.importSingleMedicineClick(currentRawData);
  }

  importSingleMedicineClick = (rawData: EmaDataRowModel) => {
    this.setState({
      isLoading: true
    });

    this.dataSyncService.importSingleMedicine(rawData)
      .then(
        (data) => {
          this.setState({
            isLoading: false
          });
          this.props.cancelClick();
        },
        error => {
          this.setState({
            isLoading: false,
            error
          });
        }
      );
  }

  handleCancelButton = () => {
    this.props.cancelClick();
  }

  onLangChange = (lang) => {
    this.setState({ selectedLangId: 2 });
  }

  handleChangeContent = (key, value) => {
    const currentRawData: EmaDataRowModel = { ...this.state.currentRawData };
    currentRawData[key] = value;

    this.setState({ currentRawData: { ...currentRawData } });
  };

  handleDocsSwitch = (e) => {

    let currentRawData: EmaDataRowModel = { ...this.state.currentRawData };
    currentRawData.isNumOfDocsDiff = e.value;
    currentRawData.numOfLeaflets = 0;
    currentRawData.numOfSmPcs = 0;

    this.setState({
      currentRawData: currentRawData,
      isNumOfDocsDiff: e.value
    });
  }

  public render() {

    const { currentRawData, selectedLangId, isLoading, error } = this.state;

    return (

      <Dialog header="Import raw data (EMA)" responsive={true} width="50%"
        modal={true}
        visible={this.props.isVisible}
        onHide={this.handleCancelButton}
        footer={
          <div>
            <Button label="Import" icon="pi pi-check" onClick={this.handleImportButton} className="p-button-raised" />
            <Button label="Cancel" icon="pi pi-times" onClick={this.handleCancelButton} className="p-button-secondary p-button-raised" />
          </div>}
      >
        <div style={{ minHeight: '450px', maxHeight: '650px' }}>
          {isLoading ? <Spinner /> : null}
          {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}
          {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
          <div style={{ maxWidth: 70 }}>
            <Language selectedLang={selectedLangId} onLangChange={this.onLangChange}></Language>
          </div>
          <div className="p-grid p-fluid p-md-12">
            <div className="p-g-12 p-md-12">
              <label>Ema Medicine URL:</label>
              <InputText
                onChange={(e) => this.handleChangeContent('emaMedicineURL', e.target['value'])}
                value={currentRawData && currentRawData.emaMedicineURL ? currentRawData.emaMedicineURL : ""}
              />
            </div>
            <div className="p-g-12 p-md-3">
              <label>Expected number of docs:</label>
              <InputText
                onChange={(e) => this.handleChangeContent('numOfDocs', e.target['value'])}
                value={currentRawData && currentRawData.numOfDocs ? currentRawData.numOfDocs : 0}
              />
            </div>
            <div className="p-g-12 p-md-3">
              {/* <h6>Number of docs differs:</h6> */}
              <label>Number of docs differs:</label>
              <InputSwitch
                onChange={(e) => this.handleDocsSwitch(e)}
                checked={this.state.isNumOfDocsDiff}>
              </InputSwitch>
            </div>
            <div className="p-g-12 p-md-3">
              <label>Number of leaflet docs:</label>
              <InputText
                disabled={!this.state.isNumOfDocsDiff}
                onChange={(e) => this.handleChangeContent('numOfLeaflets', e.target['value'])}
                value={currentRawData && currentRawData.numOfLeaflets ? currentRawData.numOfLeaflets : 0}
              />
            </div>
            <div className="p-g-12 p-md-3">
              <label>Number of SmPC docs:</label>
              <InputText
                disabled={!this.state.isNumOfDocsDiff}
                onChange={(e) => this.handleChangeContent('numOfSmPcs', e.target['value'])}
                value={currentRawData && currentRawData.numOfSmPcs ? currentRawData.numOfSmPcs : 0}
              />
            </div>
            <div className="p-g-12 p-md-12">
              <label>Medicine Name:</label>
              <InputText
                name="medicineName"
                onChange={(e) => this.handleChangeContent('medicineName', e.target['value'])}
                value={currentRawData && currentRawData.medicineName ? currentRawData.medicineName : ""}
              />
            </div>
            <div className="p-g-12 p-md-12">
              <label>Common INN names:</label>
              <InputText
                onChange={(e) => this.handleChangeContent('commonINNnames', e.target['value'])}
                value={currentRawData && currentRawData.commonINNnames ? currentRawData.commonINNnames : ""}
              />
            </div>
            <div className="p-g-12 p-md-12">
              <label>Active Substances:</label>
              <InputText
                onChange={(e) => this.handleChangeContent('activeSubstances', e.target['value'])}
                value={currentRawData && currentRawData.activeSubstances ? currentRawData.activeSubstances : ""}
              />
            </div>
            <div className="p-g-12 p-md-6">
              <label>Product Number:</label>
              <InputText
                onChange={(e) => this.handleChangeContent('productNumber', e.target['value'])}
                value={currentRawData && currentRawData.productNumber ? currentRawData.productNumber : ""}
              />
            </div>
            <div className="p-g-12 p-md-6">
              <label>ATC Code:</label>
              <InputText
                onChange={(e) => this.handleChangeContent('atcCode', e.target['value'])}
                value={currentRawData && currentRawData.atcCode ? currentRawData.atcCode : ""}
              />
            </div>
            <div className="p-g-12 p-md-6">
              <label>Authorization Holder:</label>
              <InputText
                onChange={(e) => this.handleChangeContent('authorizationHolderName', e.target['value'])}
                value={currentRawData && currentRawData.authorizationHolderName ? currentRawData.authorizationHolderName : ""}
              />
            </div>
            <div className="p-g-12 p-md-6">
              <label>Revision Date:</label>
              <InputText
                onChange={(e) => this.handleChangeContent('revisionDate', e.target['value'])}
                value={currentRawData && currentRawData.revisionDate ? currentRawData.revisionDate : ""}
              />
            </div>
          </div>
        </div>
      </Dialog >
    )
  }
}

export default ImportDataAddNewDialog;